var BrowseErrorHtml, BrowseErrorMessageTemplate, BrowseErrorPresenter;

BrowseErrorPresenter = require('../presenters/error');

BrowseErrorMessageTemplate = require('../../error_message.html.mustache');

module.exports = BrowseErrorHtml = function() {
  var hash, presenter;
  presenter = new BrowseErrorPresenter;
  hash = presenter.toHash();
  return BrowseErrorMessageTemplate.render(hash);
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWJzaGFybWEvbmFwaXN0cmFuby9idWlsZC8xNDg2Njc1NjI0Mjc0LTc0Mzcvc3RhZ2luZy1wZXJmLTIwMTcuMDIuMDlfMDAuMzUvZ29vZHMvbW9kdWxlcy9icm93c2UvZnJvbnRlbmQvdmlld3MvZXJyb3IuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWJzaGFybWEvbmFwaXN0cmFuby9idWlsZC8xNDg2Njc1NjI0Mjc0LTc0Mzcvc3RhZ2luZy1wZXJmLTIwMTcuMDIuMDlfMDAuMzUvZ29vZHMvbW9kdWxlcy9icm93c2UvZnJvbnRlbmQvdmlld3MvZXJyb3IuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsb0JBQUEsR0FBdUIsT0FBQSxDQUFRLHFCQUFSOztBQUN2QiwwQkFBQSxHQUE2QixPQUFBLENBQVEsbUNBQVI7O0FBRTdCLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLGVBQUEsR0FBa0IsU0FBQTtBQUNqQyxNQUFBO0VBQUEsU0FBQSxHQUFZLElBQUk7RUFDaEIsSUFBQSxHQUFPLFNBQVMsQ0FBQyxNQUFWLENBQUE7U0FDUCwwQkFBMEIsQ0FBQyxNQUEzQixDQUFrQyxJQUFsQztBQUhpQyJ9
